'use client'
import React, { useState } from 'react';

const SportsIndustries = ({ color, textcolor, active, activetext }) => {
  const [activeTab, setActiveTab] = useState('first');

  return (
    <section className={`${color} text-${textcolor} mt-20`}>
      <div className="container mt-5">
        <div className="text-center">
          <h2 className="sec-subtile-6">IT Solutions for Sports Industry</h2>
        </div>
        <h3 className="text-center py-3">Comprehensive IT Solutions for the Sports Industry</h3>
        <p className="text-center py-3">
          JBcodeapp offers state-of-the-art IT solutions tailored for sports teams, organizations, and events to improve performance, fan engagement, and management efficiency.
        </p>
        <div className="row mt-5">
          {/* Tab section */}
          <div className="col-md-3 col-sm-12 py-2">
            <div className="d-flex flex-column align-items-center  h-100">

              <div className="d-block d-sm-none overflow-x-auto whitespace-nowrap w-100">
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'first' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('first')}
                >
                  Sports Analytics Solutions
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'second' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('second')}
                >
                  Fan Engagement Platforms
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'third' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('third')}
                >
                  Sports Event Management Software
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'four' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('four')}
                >
                  Team & Player Management Systems
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'five' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('five')}
                >
                  Sports Betting Software Solutions
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'six' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('six')}
                >
                  AI-Powered Injury Prevention Systems
                </button>
              </div>

              <div className="d-none d-sm-flex flex-column ">
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'first' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('first')}
                >
                  Sports Analytics Solutions
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'second' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('second')}
                >
                  Fan Engagement Platforms
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'third' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('third')}
                >
                  Sports Event Management Software
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'four' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('four')}
                >
                  Team & Player Management Systems
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'five' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('five')}
                >
                  Sports Betting Software Solutions
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'six' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('six')}
                >
                  AI-Powered Injury Prevention Systems
                </button>
              </div>
            </div>
          </div>


          {/* Icon section */}
          <div className="col-md-9 col-sm-12 ">
            <div className="-brand__list -showcase-mixitup mt-3">
              {/* First Tab: EMR Solutions */}
              {activeTab === 'first' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Sports Analytics Solutions</h3>
                        <p>
                          Leverage data-driven insights to optimize team performance and fan engagement.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Real-Time Player Performance Analysis</h4>
                          <p>Track and monitor live player performance metrics.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Injury Prediction & <br />Prevention</h4>
                          <p>Use predictive analytics to prevent player injuries.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Match Data <br />Analytics</h4>
                          <p>Analyze in-depth match statistics to improve strategies.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Fan Sentiment <br />Analysis</h4>
                          <p>Gather insights into fan reactions and engagement.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Advanced Reporting Dashboards</h4>
                          <p>Customize and visualize performance data.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">A/B Testing of Game Strategies</h4>
                          <p>Test various game tactics using historical data.</p>
                        </div>
                      </div>
                    </div>
                  </section>

                </>
              )}

              {/* Second Tab: Telemedicine Solutions */}
              {activeTab === 'second' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Fan Engagement Platforms</h3>
                        <p>
                          Engage and retain your fan base through innovative digital experiences.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Live Streaming & Commentary</h4>
                          <p>Provide live game streaming with real-time commentary.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Fan Interaction <br />Zones</h4>
                          <p>Enable social sharing, discussions, and in-app interactions.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Loyalty Programs & <br />Rewards</h4>
                          <p>Offer personalized rewards and loyalty incentives.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Push Notifications & Alerts</h4>
                          <p>Notify fans about upcoming games and important news.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Social Media Integration</h4>
                          <p>Connect with fans through popular social media platforms.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">In-Game Voting & Polls</h4>
                          <p>Increase engagement with interactive fan polls during games.</p>
                        </div>
                      </div>
                    </div>
                  </section>

                </>
              )}

              {/* Third Tab: HMS Solutions */}
              {activeTab === 'third' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Sports Event Management Software</h3>
                        <p>
                          Simplify the management of sports events, ticketing, and schedules with cloud-based solutions.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Event Scheduling & Calendar Integration</h4>
                          <p>Organize and track sports events seamlessly.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Ticketing <br />Systems</h4>
                          <p>Sell, manage, and easily validate tickets online for events.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Vendor & Sponsor Management</h4>
                          <p>Manage sponsor relationships and event vendors effectively.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Volunteer Coordination Tools</h4>
                          <p>Streamline volunteer management and communication.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Event Marketing Automation</h4>
                          <p>Automate promotional campaigns for upcoming events.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Post-Event Reporting</h4>
                          <p>Analyze performance and metrics from each event.</p>
                        </div>
                      </div>
                    </div>
                  </section>

                </>
              )}

              {/* Fourth Tab: HIE Solutions */}
              {activeTab === 'four' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Team & Player Management Systems</h3>
                        <p>
                          Optimize your team’s performance with integrated player and team management tools.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Player Profiles & Stats Management</h4>
                          <p>Track and manage player performance stats.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Team Communication <br/>Tools</h4>
                          <p>Enable real-time communication between coaches and players.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Training Schedules & <br/>Regimes</h4>
                          <p>Set and track training sessions and player progress.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Player Health & Fitness Tracking</h4>
                          <p>Monitor players' health data and fitness levels.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Performance Goal <br/>Setting</h4>
                          <p>Set and monitor individual and team performance goals.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Contract & Salary Management</h4>
                          <p>Handle contracts, negotiations, and payroll efficiently.</p>
                        </div>
                      </div>
                    </div>
                  </section>

                </>
              )}

              {/* Five Tab: HIE Solutions */}
              {activeTab === 'five' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Sports Betting Software Solutions</h3>
                        <p>
                          Enhance the sports betting experience with secure and feature-rich platforms.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Real-Time Odds Calculation</h4>
                          <p>Provide dynamic odds based on live game data.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Betting Slip Management</h4>
                          <p>Allow users to create and manage their betting slips easily.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">In-Game Betting</h4>
                          <p>Enable bets during live matches with up-to-the-minute odds.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Payment Gateway <br/>Integration</h4>
                          <p>Support secure payments with multiple options.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Compliance & Regulatory Tools</h4>
                          <p>Ensure compliance with industry standards and regulations.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Betting <br/>Analytics</h4>
                          <p>Provide insights and reports for bettors and operators.</p>
                        </div>
                      </div>
                    </div>
                  </section>

                </>
              )}

              {/* Six Tab: HIE Solutions */}
              {activeTab === 'six' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">AI-Powered Injury Prevention Systems</h3>
                        <p>
                          Leverage AI and machine learning to prevent injuries and enhance player longevity.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Injury Risk Analysis</h4>
                          <p>Predict potential injury risks based on player data.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Performance Monitoring</h4>
                          <p>Track player performance in real time to detect fatigue.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Training Optimization</h4>
                          <p>Use AI to suggest optimal training intensity and duration.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Historical Data Analysis</h4>
                          <p>Analyze past injuries to prevent future occurrences.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Personalized Training Plans</h4>
                          <p>Create AI-driven personalized training schedules for players.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Real-Time Health Monitoring</h4>
                          <p>Continuously monitor player health metrics with wearables.</p>
                        </div>
                      </div>
                    </div>
                  </section>

                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default SportsIndustries;
